module.exports = __webpack_public_path__ + "img/print_handprint@2x.003cc7c.webp";